import { createFileRoute, useParams } from "@tanstack/react-router";
import { CompanyDetailViewPage } from "@/pages/company/CompanyDetailViewPage.tsx";

export const Route = createFileRoute("/_auth/unternehmen/$companyId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { companyId: companyIdParam } = useParams({
    from: "/_auth/unternehmen/$companyId",
  });

  const companyId = Number(companyIdParam);
  if (!Number.isFinite(companyId)) {
    return <div>Ungültige companyId: {companyIdParam}</div>;
  }

  return <CompanyDetailViewPage companyId={companyId} />;
}
